import React from 'react';
import { ProductType, VehicleType } from '../components/common/CommonTypes';
import useTyreRepairRequest from '../components/hooks/useTyreRepairRequest';
import { TyrePageState } from '../components/sitePages/tyreRepairRequest/TyreRepairRequestTypes';
import { TyreRepairRequestContext } from './TyreRepairRequestContext';

type TyreRepairRequestProviderProps = {
    children: React.ReactNode;
    initialState: TyrePageState;
    product: ProductType;
    vehicle: VehicleType;
};

const TyreRepairRequestProvider = ({
    children,
    initialState,
    product,
    vehicle
}: TyreRepairRequestProviderProps): JSX.Element => {
    const {
        progressBarItems,
        tyreRepairRequest,
        onSelectTyreType,
        onChangeMileage,
        onTyreValueChange,
        onTyreRepairRequestChangeTyre,
        onTyreSelected,
        onChangeDamageType,
        onRepairAddressSelectionChanged,
        onDealerAddressUpdate,
        onUploadImageChange,
        onPoliceReportChange,
        onTogglePermission,
        onFinishedTyreRepairRequest,
        onCancelClick,
        onCancelRepairRequest,
        onCancelUndo,
        onChangeStage,
        onUpdateTyreClick,
        onUpdateAddressClick,
        onContinueRepairRequest,
        onContinueToRepairAddress,
        onFinishAddingTyres,
        onDeleteRepairRequest,
        onChangDateOfIncident,
        onDefaultDealerAddressUpdate
    } = useTyreRepairRequest(initialState, product, vehicle);

    return (
        <TyreRepairRequestContext.Provider
            value={{
                product,
                vehicle,
                progressBarItems,
                tyreRepairRequest,
                onSelectTyreType,
                onChangeMileage,
                onTyreValueChange,
                onTyreRepairRequestChangeTyre,
                onTyreSelected,
                onChangeDamageType,
                onRepairAddressSelectionChanged,
                onDealerAddressUpdate,
                onUploadImageChange,
                onPoliceReportChange,
                onTogglePermission,
                onFinishedTyreRepairRequest,
                onCancelClick,
                onCancelRepairRequest,
                onCancelUndo,
                onChangeStage,
                onUpdateTyreClick,
                onUpdateAddressClick,
                onContinueRepairRequest,
                onContinueToRepairAddress,
                onFinishAddingTyres,
                onDeleteRepairRequest,
                onChangDateOfIncident,
                onDefaultDealerAddressUpdate
            }}>
            {children}
        </TyreRepairRequestContext.Provider>
    );
};

export default TyreRepairRequestProvider;
